import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/customer_/$customerId/contacts")(
  {
    staticData: { breadcrumb: "Contacts" },
  },
)
